import { useState, useEffect } from "react";
import api from "../utils/api";

/**
 * Returns the user's company name.
 * Reads from localStorage first; if missing, fetches from API and caches it.
 */
export function useUserCompanyName(): string | null {
  const [companyName, setCompanyName] = useState<string | null>(
    () => localStorage.getItem("userCompanyName")
  );

  useEffect(() => {
    if (companyName) return;

    const companyId = localStorage.getItem("userCompanyId");
    if (!companyId) return;

    let cancelled = false;
    api.get("/company", { params: { id: companyId } })
      .then(({ data }) => {
        if (cancelled) return;
        // Handle nested response: data.data.data or data.data
        const company = data?.data?.data || data?.data || data;
        const name = company?.name || company?.business_name || "";
        if (name) {
          localStorage.setItem("userCompanyName", name);
          setCompanyName(name);
        }
      })
      .catch(() => {
        // silently ignore – company name is non-critical
      });

    return () => { cancelled = true; };
  }, [companyName]);

  return companyName;
}
